import { render, staticRenderFns } from "./GiftCardConfigPane.vue?vue&type=template&id=d8d15b64&scoped=true"
import script from "./GiftCardConfigPane.vue?vue&type=script&lang=js"
export * from "./GiftCardConfigPane.vue?vue&type=script&lang=js"
import style0 from "./GiftCardConfigPane.vue?vue&type=style&index=0&id=d8d15b64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d15b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8d15b64')) {
      api.createRecord('d8d15b64', component.options)
    } else {
      api.reload('d8d15b64', component.options)
    }
    module.hot.accept("./GiftCardConfigPane.vue?vue&type=template&id=d8d15b64&scoped=true", function () {
      api.rerender('d8d15b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/GiftCardConfigPane.vue"
export default component.exports